import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "line-icon",
  viewBox: "0 0 24 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20 16h-4a4 4 0 0 1-4-4V0M12 12v20" }, null, -1)
  ])))
}
export default { render: render }